var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8097 40C25.3344 40 32.0454 35.1521 32.0074 28.289C32.0454 23.5171 28.8515 20.1521 22.5777 19.4677V19.1635C27.2165 18.6692 30.6005 15.6844 30.5625 11.3308C30.6005 4.77186 24.5169 0 15.8857 0C7.06443 0 0.790667 5.03802 0.752644 12.1673H10.8667C10.9047 9.80989 12.977 8.13688 15.8857 8.13688C18.5473 8.13688 20.4104 9.75285 20.3724 12.0152C20.4104 14.3726 18.2051 16.0456 15.0492 16.0456H11.0948V23.346H15.0492C18.4713 23.346 20.8667 25.019 20.8287 27.3764C20.8667 29.7909 18.8135 31.4829 15.8857 31.4829C12.8439 31.4829 10.6766 29.8669 10.6386 27.6046H-0.0078125C0.0302103 34.8669 6.58914 40 15.8097 40Z",
    fill: "url(#paint0_linear_77_11227)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_11227",
    x1: -0.00781787,
    y1: 39.9999,
    x2: 34.3675,
    y2: 37.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.15e66ad9769e9a7952adb9402ff1d3bf.svg";
export { ForwardRef as ReactComponent };